import { Component } from '@angular/core';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-tournament-edit-button-cell',
  templateUrl: './tournament-edit-button-cell.component.html',
  styleUrls: ['./tournament-edit-button-cell.component.css'],
})
export class TournamentEditButtonCellComponent implements AgRendererComponent {
  tournamentId: string;

  faEdit = faEdit;
  constructor() {}
  refresh(params: ICellRendererParams): boolean {
    this.tournamentId = params.data.id;
    return true;
  }
  agInit(params: ICellRendererParams): void {
    this.tournamentId = params.data.id;
  }
}
